import { SortOptionDto, SortConfigurationDto } from "@/shared/api-contract/api-contract";
import { useI18n } from "@/shared/composables/use-i18n";
import { setup } from "vue-class-component";
import { Model, Prop, Vue } from "vue-property-decorator";

export class AppSortBlockComponent extends Vue {
    i18n = setup(useI18n);

    @Model("sort", { required: true })
    sortModel!: SortConfigurationDto;

    @Prop()
    sortOptions!: SortOptionDto[];

    @Prop({ default: false, required: false })
    unsetFixedWidth!: boolean;

    get placeholder() {
        const { id_direction, id_field } = this.sortModel;
        const selectedItem = this.sortOptions?.find(({ configuration }) => {
            return (
                +configuration.id_direction === +id_direction &&
                +configuration.id_field === +id_field
            );
        });
        return (
            selectedItem?.description ??
            this.i18n.t("dashboard.myFavoritesComponent.sortByDropdown.priceLowToHigh")
        );
    }
    fontSize = "12px";
}
